module.exports = __webpack_public_path__ + "img/icon_request_tech_assistance_services_hover.6f3a7c7b.svg";